import { render, staticRenderFns } from "./TPF2.vue?vue&type=template&id=0c68d764"
import script from "./TPF2.vue?vue&type=script&lang=js"
export * from "./TPF2.vue?vue&type=script&lang=js"
import style0 from "./TPF2.vue?vue&type=style&index=0&id=0c68d764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports